const ACTIVE_SCHOOL_KEY = 'activeSchool';

/** @typedef {{ schoolId: number, schoolName: string, schoolLogo?: string|null, accessRole: string, studentId?: number|null, isDemoSchool?: boolean }} ActiveSchool */

export function getActiveSchool() {
    try {
        const raw = localStorage.getItem(ACTIVE_SCHOOL_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.schoolId) return null;
        return parsed;
    } catch {
        return null;
    }
}

/** @param {ActiveSchool|null} entry */
export function setActiveSchool(entry) {
    if (!entry?.schoolId) {
        localStorage.removeItem(ACTIVE_SCHOOL_KEY);
        return;
    }
    localStorage.setItem(ACTIVE_SCHOOL_KEY, JSON.stringify(entry));
    // совместимость со старым ключом ученика
    localStorage.setItem('memberSchoolId', String(entry.schoolId));
}

export function clearActiveSchool() {
    localStorage.removeItem(ACTIVE_SCHOOL_KEY);
    localStorage.removeItem('memberSchoolId');
}

export function getActiveSchoolId() {
    return getActiveSchool()?.schoolId ?? null;
}

/**
 * ID школы, которой владеет пользователь — для /billing и платформенного биллинга.
 * Не использует activeSchool тренера в чужой школе.
 */
export function getOwnedSchoolIdForBilling() {
    const active = getActiveSchool();
    if (active?.schoolId && (active.accessRole === 'owner' || active.accessRole === 'demo')) {
        return active.schoolId;
    }
    if (active?.schoolId && active.isFreelanceSchool) {
        return active.schoolId;
    }
    try {
        const profiles = JSON.parse(localStorage.getItem('profiles') || '[]');
        const owned = profiles.find((p) =>
            p.type === 'Owner' && p.schoolId
        );
        if (owned?.schoolId) return owned.schoolId;
    } catch {
        /* ignore */
    }
    const accountRole = localStorage.getItem('accountRole') || localStorage.getItem('role');
    if (accountRole === 'Owner' && active?.accessRole === 'owner' && active.schoolId) {
        return active.schoolId;
    }
    return null;
}

export function isOwnedFreelanceSchoolForBilling() {
    const active = getActiveSchool();
    const ownedId = getOwnedSchoolIdForBilling();
    if (!ownedId) return false;
    if (active?.schoolId === ownedId && active.isFreelanceSchool) return true;
    return localStorage.getItem('isFreelance') === 'true';
}

export function getActiveStudentId() {
    const s = getActiveSchool();
    return s?.studentId ?? null;
}

export function isViewingDemoSchool() {
    const active = getActiveSchool();
    return active?.isDemoSchool === true || active?.accessRole === 'demo';
}

export function isActiveSchoolValidInList(schools, demoSchools = []) {
    const active = getActiveSchool();
    if (!active) return false;
    if (schools.some(s => s.schoolId === active.schoolId)) return true;
    if (demoSchools.some(d => (d.id ?? d.schoolId) === active.schoolId)) return true;
    return isViewingDemoSchool();
}
